module.exports = __webpack_public_path__ + "img/del-car.5e260037.jpeg";